import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

/**
 * Guard de rota para `/admin/*` (AB#64 — bugs 2 e 5).
 *
 * - Sem sessão → vai pro /login.
 * - Usuário autenticado mas perfil != SUPER_ADMIN → vai pro /dashboard.
 *   Reforça a regra antes que a página renderize um modal global (ex.
 *   ReleaseNotesModal) sobre uma tela proibida.
 *
 * Detecta sessão por `usuario` (persistido em localStorage), não por
 * `access_token` — o access_token NÃO sobrevive a F5 (REQ-003 RN-05) e
 * usá-lo aqui faria F5 em qualquer /admin/* virar redirect pra /login.
 * O apiFetch chama /auth/refresh sob demanda quando o token expira.
 *
 * Cada página /admin/* ainda mantém o próprio check para defense-in-depth.
 */
export function AdminRoute({ children }: { children: JSX.Element }): JSX.Element {
  const usuario = useAuthStore((s) => s.usuario);
  if (!usuario) return <Navigate to="/login" replace />;
  if (usuario.perfil !== 'SUPER_ADMIN') return <Navigate to="/dashboard" replace />;
  return children;
}
